import { apiGet, getFullyQualifiedAPIUrl } from '@/core/api';
import { CitizenApplicationsStatus } from './model';
import { DraftApplicationHeader } from '../applications/model';
import { Core } from '@minicity/core';
import { sessionState } from '@/core/session';

export const getApplicationStatus = async (citizenId: string) =>
    apiGet<CitizenApplicationsStatus>(`citizens/${citizenId}/applications`);

export const getDraftApplications = async (citizenId: string) =>
    apiGet<DraftApplicationHeader[]>(`citizens/${citizenId}/draftApplications`);

export const getAttachmentViewLink = (doc: Core.Document) =>
    apiGet<string>(`citizens/${sessionState.session?.user.id}/viewToken`, "text/plain")
        .then(viewToken => getFullyQualifiedAPIUrl(`citizens/${sessionState.session?.user.id}/attachments/${doc.id}?token=${encodeURIComponent(viewToken)}`));